{
  "AGENT_BOTS": {
    "HEADER": "Bots",
    "LOADING_EDITOR": "Loading editor...",
    "DESCRIPTION": "Agent Bots are like the most fabulous members of your team. They can handle the small stuff, so you can focus on the stuff that matters. Give them a try.You can manage your bots from this page or create new ones using the 'Configure new bot' button.",
    "LEARN_MORE": "Learn about agent bots",
    "GLOBAL_BOT": "Bot di sistema",
    "GLOBAL_BOT_BADGE": "Sistema",
    "AVATAR": {
      "SUCCESS_DELETE": "Avatar del bot eliminato correttamente",
      "ERROR_DELETE": "Errore durante l'eliminazione dell'avatar del bot, riprova"
    },
    "BOT_CONFIGURATION": {
      "TITLE": "Select an agent bot",
      "DESC": "Assign an Agent Bot to your inbox. They can handle initial conversations and transfer them to a live agent when necessary.",
      "OPTION": "{name} ({description})",
      "SUBMIT": "Aggiorna",
      "DISCONNECT": "Disconnect bot",
      "SUCCESS_MESSAGE": "Successfully updated the agent bot.",
      "DISCONNECTED_SUCCESS_MESSAGE": "Successfully disconnected the agent bot.",
      "ERROR_MESSAGE": "Could not update the agent bot. Please try again.",
      "DISCONNECTED_ERROR_MESSAGE": "Could not disconnect the agent bot. Please try again.",
      "SELECT_PLACEHOLDER": "Select bot",
      "COUNTRY_BOTS": {
        "TITLE": "Bot per paese",
        "DESC": "Questa casella serve più paesi. Una conversazione va al bot del suo paese: in base al negozio Kaufland, al marketplace dell'ordine Allegro oppure, in mancanza, alla lingua in cui scrive il cliente. Tutte le altre conversazioni vanno al bot predefinito qui sopra.",
        "COUNTRY": "Seleziona un paese",
        "BOT": "Seleziona il bot",
        "ADD": "Aggiungi bot per un paese",
        "REMOVE": "Rimuovi",
        "DEFAULT_REQUIRED": "Seleziona prima un bot predefinito. Il bot di un paese lo sostituisce solo per quel paese.",
        "DISCONNECT_ALL": "Disconnetti tutti i bot"
      }
    },
    "ADD": {
      "TITLE": "Configure new bot",
      "CANCEL_BUTTON_TEXT": "Annulla",
      "API": {
        "SUCCESS_MESSAGE": "Bot added successfully.",
        "ERROR_MESSAGE": "Could not add bot. Please try again later."
      }
    },
    "LIST": {
      "404": "No bots found. You can create a bot by clicking the 'Configure new bot' button ↗",
      "LOADING": "Fetching bots...",
      "TABLE_HEADER": {
        "DETAILS": "Dettagli bot",
        "URL": "URL Webhook"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Elimina",
      "TITLE": "Delete bot",
      "CONFIRM": {
        "TITLE": "Conferma eliminazione",
        "MESSAGE": "Sei sicuro di voler eliminare {name}?",
        "YES": "Sì, elimina",
        "NO": "No, mantieni"
      },
      "API": {
        "SUCCESS_MESSAGE": "Bot deleted successfully.",
        "ERROR_MESSAGE": "Could not delete bot. Please try again."
      }
    },
    "EDIT": {
      "BUTTON_TEXT": "Modifica",
      "TITLE": "Edit bot",
      "API": {
        "SUCCESS_MESSAGE": "Bot updated successfully.",
        "ERROR_MESSAGE": "Could not update bot. Please try again."
      }
    },
    "FORM": {
      "AVATAR": {
        "LABEL": "Avatar del bot"
      },
      "NAME": {
        "LABEL": "Nome del bot",
        "PLACEHOLDER": "Inserisci il nome del bot",
        "REQUIRED": "Il nome del bot è obbligatorio"
      },
      "DESCRIPTION": {
        "LABEL": "Descrizione",
        "PLACEHOLDER": "Cosa fa questo bot?"
      },
      "WEBHOOK_URL": {
        "LABEL": "URL Webhook",
        "PLACEHOLDER": "https://example.com/webhook",
        "REQUIRED": "L'URL del webhook è obbligatorio"
      },
      "ERRORS": {
        "NAME": "Il nome del bot è obbligatorio",
        "URL": "L'URL del webhook è obbligatorio",
        "VALID_URL": "Inserisci un URL valido che inizi con http:// o https://"
      },
      "CANCEL": "Annulla",
      "CREATE": "Crea bot",
      "UPDATE": "Aggiorna bot"
    },
    "WEBHOOK": {
      "DESCRIPTION": "Configura un bot webhook per integrarlo con i tuoi servizi personalizzati. Il bot riceverà ed elaborerà eventi dalle conversazioni e potrà rispondere ad essi."
    },
    "TYPES": {
      "WEBHOOK": "Webhook bot"
    }
  }
}
